import { useSelector, useDispatch } from "react-redux"

const useDeleteTimelineModal = () => {
    const dispatch = useDispatch()
    const reduxData = useSelector((state) => state.modal.counseling.deleteTimelineModal)
    const {isOpen} = reduxData

    const setOpen = (open, onChange = () => {}, timelineId = null, useMutation = false) => {
        dispatch({
            type: 'SET_DATA_MODAL_FORM_LIST',
            payload: 'counseling.deleteTimelineModal',
            data: {
                ...reduxData,
                isOpen: open,
                onChange,
                timelineId,
                useMutation
            }
        })
    }
    return {
        ...reduxData,
        open: (onChange = () => {}, timelineId = null, useMutation = false) => {
            setOpen(true, onChange, timelineId, useMutation)
        },
        close: () => {setOpen(false)},
        toggle: () => {setOpen(!isOpen)}
    }
}

export default useDeleteTimelineModal